import { Component, Input, OnInit } from '@angular/core';
import { DocumentoPac } from 'src/app/model/DocumentoPac';
import { ArquivosAnexadosView } from 'src/app/model/view/ArquivosAnexadosView';
import { AnexosService } from 'src/app/services/anexos.service';

@Component({
  selector: 'app-informacoes-dos-anexos',
  templateUrl: './informacoes-dos-anexos.component.html',
  styleUrls: ['./informacoes-dos-anexos.component.scss'],
  standalone: false
})
export class InformacoesDosAnexosComponent implements OnInit {
  @Input() documentoPac: DocumentoPac = new DocumentoPac();

  arquivosAnexos: ArquivosAnexadosView[]

  constructor(private anexosService: AnexosService) { }

  ngOnInit(): void {
    this.anexosService.obterAnexos(this.documentoPac.id).subscribe({
      next: (response: ArquivosAnexadosView[]) => {
        this.arquivosAnexos = response.length === 0 ? undefined : response;
        this.ajustarLinks(this.arquivosAnexos)
      }
    })
  }

  buscarCategorias(anexo: ArquivosAnexadosView){
    return anexo.categoriaAnexo.split("::")
  }

  ajustarLinks(arquivosAnexos: ArquivosAnexadosView[]) {
    if (arquivosAnexos) {
      arquivosAnexos.forEach((a)=>{
        a.link = this.anexosService.linkDownload(a);
      })
    }
  }
}

